<template>
    <x-page title="Add Template Statistik">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <group-statistic-template-form id="group-statistic-template-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors" />
        <template #footer>
            <x-submit-button form="group-statistic-template-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleValidationXhrError } from '../../helpers'
import GroupStatisticTemplateForm from './GroupStatisticTemplateForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        GroupStatisticTemplateForm,
    },
    data() {
        return {
            errors: null,
            isLoading: false,
        }
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.post(`/api/group-statistic-templates`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} added!`,
                    })
                    this.$router.back()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
}
</script>